import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import GroupsIcon from "@mui/icons-material/Groups";
import Loading from "../../../../components/Loading/Loading";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import TableAllRunningsClubsProvider from "./TableRunningsClubs/TableRunningsClubs";
import ModalClubForm from "./ModalRunningClub/ModalRunningClub";
import { useDispatch, useSelector } from "react-redux";
import ButtonHireMembership from "../../../../components/ButtonHireMembership/ButtonHireMembreship";
import { getAllRunningsClubsOfProvider } from "../../../../services/rest/runningsClubs/runningClubsProviderService";
import { setRunningsClubsOfCoach } from "../../../../redux/slice/runningsClubsSlice";

const RunningsClubsProvider = () => {
  const { membershipStatus } = useSelector((state) => state.membershipReducer);
  const { runningsClubsOfCoach } = useSelector(
    (state) => state.runningsClubsReducer
  );
  const dispatch = useDispatch();
  const [listClubs, setListClubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModalCreateClub, setShowModalCreateClub] = useState(false);

  useEffect(() => {
    const getListClubsOfProvider = async () => {
      try {
        setLoading(true);
        const listResponseClubs = await getAllRunningsClubsOfProvider();
        //Validamos status de la membresía
        if (membershipStatus !== "active") {
          dispatch(setRunningsClubsOfCoach({ runningsClubsOfCoach: [] }));
          toast.error("Su membresía no esta activa.", 50000);
          setLoading(false);
          return;
        }
        dispatch(
          setRunningsClubsOfCoach({
            runningsClubsOfCoach: listResponseClubs ?? [],
          })
        );
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error(
          "No pudimos obtener los usuarios.  \n Intentelo más tarde."
        );
      }
    };
    getListClubsOfProvider();
  }, []);

  return (
    <Box sx={{ paddingLeft: 4, paddingRight: 4 }}>
      <ModalClubForm
        open={showModalCreateClub}
        setLoading={setLoading}
        setOpen={setShowModalCreateClub}
      />
      <Loading loading={loading} />
      <Box sx={{ display: "flex", gap: 4, alignItems: "center" }}>
        <Box sx={{ display: "flex", gap: 2 }}>
          <GroupsIcon style={{ fontSize: 32 }} />
          <Typography variant="h5">Runnings Clubs</Typography>
          {membershipStatus !== "active" && <ButtonHireMembership />}
        </Box>
        {membershipStatus === "active" && (
          <Button
            variant="contained"
            sx={{ backgroundColor: "#e7ef7d", height: 40 }}
            onClick={() => setShowModalCreateClub(true)}
            startIcon={<GroupAddIcon />}
          >
            Crear Club
          </Button>
        )}
      </Box>
      <Box sx={{ paddingTop: 4 }}>
        <TableAllRunningsClubsProvider
          rows={runningsClubsOfCoach}
          setLoading={setLoading}
          setListClubs={setListClubs}
        />
      </Box>
    </Box>
  );
};

export default RunningsClubsProvider;
